import { CommonKeys } from "../../common/enums";
import { CATEGORY_GROUP_TYPE, CATEGORY_GROUPS_TYPE, DYNAMIC_FIELD_CATEGORIES_TYPE, DYNAMIC_FIELD_CATEGORY_TYPE, DYNAMIC_FIELDS_FIELD, DYNAMIC_FIELDS_FIELDS, FORMULAR_GROUP_DYNAMIC_FIELDS_TYPE } from "../../common/formular-group-types";

const FormularGroupDynamicFieldsSchema = {
    $id: "FormularGroupDynamicFieldsSchema",
    title: "FormularGroupDynamicFields Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_GROUP_DYNAMIC_FIELDS_TYPE },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string", nullable: true },
        [CommonKeys.ShowLabel]: { type: "boolean", nullable: true },
        LayoutDefinitionID: { type: "number" },
        Categories: { $ref: "FormularGroupDynamicFieldsCategoriesSchema" }
    },
    required: [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label, CommonKeys.ShowLabel]
}

const FormularGroupDynamicFieldsCategoriesSchema = {
    $id: "FormularGroupDynamicFieldsCategoriesSchema",
    title: "FormularGroupDynamicFieldsCategories Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: DYNAMIC_FIELD_CATEGORIES_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: { $ref: "FormularGroupDynamicFieldsCategorySchema" }
        }
    }
}

const FormularGroupDynamicFieldsCategorySchema = {
    $id: "FormularGroupDynamicFieldsCategorySchema",
    title: "FormularGroupDynamicFieldsCategory Schema",
    type: "object",
    allOf: [
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: DYNAMIC_FIELD_CATEGORY_TYPE },
                [CommonKeys.ID]: { type: "number", nullable: true },
                [CommonKeys.Label]: { type: "string", nullable: true },
                UniqueName: { type: "string", nullable: true },
            },
            required: [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label, "UniqueName"]
        },
        {
            type: "object",
            anyOf: [
                {
                    properties: {
                        Groups: { $ref: "DynamicFieldsCategoryGroupsSchema" }
                    },
                    required: ["Groups"]
                },
                {
                    properties: {
                        Fields: { $ref: "CategoryFieldsSchema" }
                    },
                    required: ["Fields"]
                }
            ]
        }
    ]
}

const DynamicFieldsCategoryGroupsSchema = {
    $id: "DynamicFieldsCategoryGroupsSchema",
    title: "DynamicFieldsCategoryGroups Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: CATEGORY_GROUPS_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: { $ref: "CategoryGroupSchema" }
        },
    }
}

const CategoryGroupSchema = {
    $id: "CategoryGroupSchema",
    title: "CategoryGroup Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: CATEGORY_GROUP_TYPE },
        [CommonKeys.ID]: { type: "number", nullable: true },
        [CommonKeys.Label]: { type: "string", nullable: true },
        UniqueName: { type: "string", nullable: true },
        Fields: { $ref: "CategoryFieldsSchema" }
    },
    required: [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label, "UniqueName"]
}

const CategoryFieldsSchema = {
    $id: "CategoryFieldsSchema",
    title: "CategoryFields Schema",
    anyOf: [
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: DYNAMIC_FIELDS_FIELDS },
                [CommonKeys.Values]: {
                    type: "array",
                    items: { $ref: "DynamicFieldsFieldSchema" }
                }
            },
            required: [CommonKeys.Type, CommonKeys.Values],
        },
        { type: "null" }
    ]
}

const DynamicFieldsFieldSchema = {
    $id: "DynamicFieldsFieldSchema",
    title: "DynamicFieldsField Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: DYNAMIC_FIELDS_FIELD },
        [CommonKeys.ID]: { type: "number", nullable: true },
        [CommonKeys.Label]: { type: "string", nullable: true },
        [CommonKeys.Value]: { type: "string", nullable: true },
        UniqueName: { type: "string", nullable: true },
        IsEyeCatching: { type: "boolean", nullable: true },
        DataType: { type: "number", nullable: true },
        InputType: { type: "number", nullable: true },
    },
    required: [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label, CommonKeys.Value, "UniqueName", "IsEyeCatching", "DataType", "InputType"]
}

export const FORMULAR_GROUP_DYNAMIC_INPUTS_SCHEMAS = [
    FormularGroupDynamicFieldsSchema,
    FormularGroupDynamicFieldsCategoriesSchema,
    FormularGroupDynamicFieldsCategorySchema,
    DynamicFieldsCategoryGroupsSchema,
    CategoryGroupSchema,
    CategoryFieldsSchema,
    DynamicFieldsFieldSchema
]